import React from "react";
import moment from "moment";
import { withTranslation, useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import DateTimePickerComponent from "./DateTimePickerComponent";

const BookingLookupComponent = (props) => {
  const { t } = useTranslation();
  const classNames = `w-full flex flex-col justify-between ${
    props.BookingInputName ? "h-72" : ""
  }`;
  return (
    <div
      id="booking-lookup"
      className="w-full flex-1 text-center capitalize xxs:text-xl md:text-2xl font-semibold pt-2 pb-2 md:flex-0 flex items-center">
      <div className={classNames}>
        <div className="md:mb-10">
          <p
            className="capitalize mb-4 type-title medium"
            style={{ color: props.backgroundColorTopBar }}>
            {props.input_call_to_action}
          </p>
          <input
            type="text"
            name={props.BookingInputName || "bookingNumber"}
            autoComplete="off"
            value={props.bookingNumber}
            onChange={props.handleChange}
            className="border-b w-full md:max-w-md px-4 text-center mx-auto leading-15 outline-none focus:outline-none type-title large"
            style={{ borderColor: props.backgroundColorTopBar }}
          />
          {!props.validateForm && isEmpty(props.bookingNumber) && (
            <p className="text-14 text-red-500 mt-5">
              {t(
                "PLEASE_FILL_OUT_REQUIRED",
                "Please fill all the required fields"
              )}
            </p>
          )}
        </div>
        {props.enableLastName && (
          <div className="md:mb-10">
            <p
              className="capitalize my-4 type-title medium"
              style={{ color: props.backgroundColorTopBar }}>
              {props.mainGuestLastNameTitle}
            </p>
            <input
              type="text"
              name={props.mainGuestLastName || "lastName"}
              autoComplete="off"
              value={props.lastName}
              onChange={props.handleChange}
              className="border-b w-full md:max-w-md px-4 text-center mx-auto leading-15 outline-none focus:outline-none type-title large"
              style={{ borderColor: props.backgroundColorTopBar }}
            />
            {!props.validateForm && isEmpty(props.lastName) && (
              <p className="text-14 text-red-500 mt-5">
                {t(
                  "PLEASE_FILL_OUT_REQUIRED",
                  "Please fill all the required fields"
                )}
              </p>
            )}
          </div>
        )}
        {props.enableEmail && (
          <div className="md:mb-10">
            <p
              className="capitalize my-4 type-title medium"
              style={{ color: props.backgroundColorTopBar }}>
              {props.mainGuestEmailTitle}
            </p>
            <input
              type="text"
              name={props.mainGuestEmail || "userEmail"}
              autoComplete="off"
              value={props.userEmail}
              onChange={props.handleChange}
              className="border-b w-full md:max-w-md px-4 text-center mx-auto leading-15 outline-none focus:outline-none type-title large"
              style={{ borderColor: props.backgroundColorTopBar }}
            />
            {!props.validateForm && isEmpty(props.userEmail) && (
              <p className="text-14 text-red-500 mt-5">
                {t(
                  "PLEASE_FILL_OUT_REQUIRED",
                  "Please fill all the required fields"
                )}
              </p>
            )}
          </div>
        )}
        {props.enableDatePicker && (
          <div>
            <p
              className="capitalize mt-10 mb-4 type-title medium"
              style={{ color: props.backgroundColorTopBar }}>
              {props.datePickerTitle}
            </p>
            <DateTimePickerComponent
              dateName={props.datePickerName}
              modalTitle={props.datePickerTitle}
              getDate={props.selectedDate}
              primaryColor={props.backgroundColorTopBar}
              borderColor={props.backgroundColorTopBar}
              handleChange={props.handleChange}
              buttonStyleName={props.buttonStyleName}
              present
              fromYear={moment().year()}
              toYear={moment().add(5, "years").year()}
              dateType="date"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default withTranslation()(BookingLookupComponent);
